import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { FormattedMessage } from "react-intl";

const logs = [
	{ time: "12:42:08", level: "info", msg: "auth.user.signup — anna@acme.io" },
	{ time: "12:39:51", level: "warn", msg: "rate_limit hit on /rest/v1/orders" },
	{ time: "12:35:14", level: "error", msg: "edge_function send-email timeout (3001ms)" },
	{ time: "12:30:02", level: "info", msg: "storage.object.uploaded — avatars/anna.png" },
	{ time: "12:24:47", level: "info", msg: "db.migration applied — 20260504_add_index" },
];

export function ActivityLog() {
	return (
		<Card>
			<CardHeader>
				<CardTitle>
					<FormattedMessage id="dashboard.activityLog.title" defaultMessage="Activity log" />
				</CardTitle>
				<CardDescription>
					<FormattedMessage
						id="dashboard.activityLog.description"
						defaultMessage="Recent events from your project"
					/>
				</CardDescription>
			</CardHeader>
			<CardContent>
				<ul className="space-y-3">
					{logs.map((l) => (
						<li key={l.time} className="flex items-start gap-3 text-sm">
							<span className="mt-0.5 font-mono text-xs text-muted-foreground">{l.time}</span>
							<Badge
								variant={
									l.level === "error"
										? "destructive"
										: l.level === "warn"
											? "secondary"
											: "outline"
								}
								className="uppercase text-[10px] tracking-wider"
							>
								{l.level}
							</Badge>
							<span className="flex-1 text-foreground/90">{l.msg}</span>
						</li>
					))}
				</ul>
			</CardContent>
		</Card>
	);
}
